import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabaseHierarchy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "database-hierarchy" }),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "a",
			cx: 6.75,
			cy: 6.751,
			rx: 6,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,6.751v4.5c0,1.657,2.686,3,6,3s6-1.343,6-3v-4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,11.251v4.5c0,1.657,2.686,3,6,3s6-1.343,6-3v-4.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 6.751,
			x2: 12.75,
			y2: 9.751
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "a",
			cx: 19.5,
			cy: 3.001,
			rx: 3.75,
			ry: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,3V7.5c0,1.242,1.679,2.25,3.75,2.25s3.75-1.008,3.75-2.25V3"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.341,
			y1: 16.842,
			x2: 15.75,
			y2: 20.251
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "a",
			cx: 19.5,
			cy: 16.501,
			rx: 3.75,
			ry: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,16.5V21c0,1.242,1.679,2.25,3.75,2.25s3.75-1.008,3.75-2.25V16.5"
		})
	]
});
export default SvgDatabaseHierarchy;
